import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Users, X } from 'lucide-react';
export function FloatingJoinButton() {
  const [isVisible, setIsVisible] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  useEffect(() => {
    // Show button after scrolling down a bit
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
        setIsMinimized(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    } else {
      // If not on home page, navigate to home page with contact hash
      window.location.href = '/#contact';
    }
  };
  return <AnimatePresence data-id="element-127">
      {isVisible && <motion.div initial={{
      opacity: 0,
      scale: 0.8,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.8,
      y: 20
    }} className="fixed bottom-6 left-6 z-40" data-id="element-128">
          {!isMinimized ? <motion.button onClick={scrollToContact} className="group relative bg-gradient-to-r from-[#0D7AB8] to-[#0A5F8F] text-white px-6 py-4 rounded-full shadow-2xl hover:shadow-blue-500/50 transition-all duration-300 flex items-center gap-3 font-bold text-lg" whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} data-id="element-129">
              <Users className="w-6 h-6" data-id="element-130" />
              <span data-id="element-131">הצטרפו אלינו</span>

              {/* Pulse animation */}
              <span className="absolute inset-0 rounded-full bg-blue-400 opacity-0 group-hover:opacity-20 animate-ping" data-id="element-132" />

              {/* Minimize button */}
              <button onClick={e => {
          e.stopPropagation();
          setIsMinimized(true);
        }} className="absolute -top-2 -right-2 bg-white text-[#0A5F8F] rounded-full p-1 shadow-lg hover:bg-gray-100 transition-colors" data-id="element-133">
                <X className="w-4 h-4" data-id="element-134" />
              </button>
            </motion.button> : <motion.button onClick={() => setIsMinimized(false)} className="bg-gradient-to-r from-[#0D7AB8] to-[#0A5F8F] text-white p-4 rounded-full shadow-2xl hover:shadow-blue-500/50 transition-all duration-300" whileHover={{
        scale: 1.1
      }} whileTap={{
        scale: 0.9
      }} data-id="element-135">
              <Users className="w-6 h-6" data-id="element-136" />
            </motion.button>}
        </motion.div>}
    </AnimatePresence>;
}